





































































import { Component, Vue } from 'vue-property-decorator'
import jsSHA from 'jssha'

@Component({ components: {} })
export default class Download extends Vue {
  loaded: boolean = false
  currentVideo: number = 0
  passwordInput: string = ''
  // 导航项配置
  navs = [
    {
      title: '课程介绍',
      navItems: [
        { index: 0, title: '星算小超人', icon: 'icon-box icon-1' }
      ]
    },
    {
      title: '手机软件（平板软件）',
      navItems: [
        { index: 1, title: '珠心算Ai学生端', subtitle: '功能简介', icon: 'icon-box icon-4' },
        { index: 2, title: '珠心算Ai学生端', subtitle: '功能详细讲解', icon: 'icon-box icon-4' },
        { index: 3, title: '珠心算Ai管理端', icon: 'icon-box icon-8' }
      ]
    },
    {
      title: '电脑软件',
      navItems: [
        { index: 4, title: '体验课', icon: 'icon-box icon-2' },
        { index: 5, title: '动画课件', icon: 'icon-box icon-3' },
        { index: 6, title: '豆苗课堂', icon: 'icon-box icon-5' },
        { index: 7, title: '豆苗出题', icon: 'icon-box icon-6' },
        { index: 8, title: '无纸化教师端', icon: 'icon-box icon-7' }
      ]
    }
  ]

  // 视频配置
  videos = [
    { title: '星算小超人', src: require('@/assets/media/xs-super-intro.mp4'), unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '珠心算Ai学生端', subtitle: '功能简介', src: 'https://s.doumiao9.com/official/media/product-xsstudent-intro.mp4', unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '珠心算Ai学生端', subtitle: '功能详细讲解', src: require('@/assets/media/xs-student-intro.mp4'), unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '珠心算Ai管理端', src: 'https://s.doumiao9.com/official/media/product-xsteacher-intro.mp4', unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '体验课', src: require('@/assets/media/dm-tyk-intro.mp4'), unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '动画课件', src: require('@/assets/media/ani-course-intro.mp4'), unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '豆苗课堂', src: require('@/assets/media/ketang-intro.mp4'), unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '豆苗出题', src: require('@/assets/media/chuti-intro.mp4'), unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' },
    { title: '无纸化教师端', src: require('@/assets/media/plteacher.mp4'), unlocked: false, password: '8ac1f61dbc11d9bdb7829e4d9aaab7df343e980ebbe15912f52a2472eaa227698d34fb6d705a28fd5f11ae9e730ec346024c946842f89579de29f184fad14bb5' }
  ]

  // 计算当前视频项
  get currentVideoItem () {
    return this.videos[this.currentVideo]
  }

  mounted () {
    this.loaded = true

    // 兼容prerender-spa-plugin
    Lib.dispatchEvent(document, 'custom-render-trigger')

    // 添加导航项点击事件监听
    this.addNavItemClickListeners()

    // 添加密码输入相关事件监听
    this.addPasswordInputListeners()
  }

  // 选择视频
  selectVideo (index: number) {
    this.currentVideo = index
    this.passwordInput = ''
    // 如果视频已解锁，直接播放
    if (this.videos[index].unlocked) {
      this.playVideo()
    }
  }

  // 解锁视频
  unlockVideo (index: number) {
    let shaObj = new jsSHA('SHA-512', 'TEXT')
    shaObj.update(this.passwordInput)
    let hash = shaObj.getHash('HEX')
    if (hash === this.videos[index].password) {
      this.videos.forEach((item) => {
        // 暂时共用一个密码 - 全部一起解锁
        item.unlocked = true
      })
      this.playVideo()
    } else {
      alert('密码错误，请重新输入')
      this.passwordInput = ''
    }
  }

  // 播放视频
  playVideo () {
    this.$nextTick(() => {
      const videoElement = this.$el.querySelector('.responsive-video') as HTMLVideoElement
      if (videoElement) {
        videoElement.play().catch(e => console.log('自动播放被阻止:', e))
      }
    })
  }

  // 添加导航项点击事件监听
  addNavItemClickListeners () {
    const navItems = this.$el.querySelectorAll('.nav-item')
    navItems.forEach((item: Element) => {
      const videoIndex = parseInt((item as HTMLElement).dataset.videoIndex || '0', 10)
      item.addEventListener('click', () => {
        this.selectVideo(videoIndex)
      })
    })
  }

  // 添加密码输入相关事件监听
  addPasswordInputListeners () {
    const passwordInput = this.$el.querySelector('.password-input-field') as HTMLInputElement
    const unlockButton = this.$el.querySelector('.unlock-button') as HTMLButtonElement

    if (passwordInput) {
      passwordInput.addEventListener('keyup', (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
          this.unlockVideo(this.currentVideo)
        }
      })
    }

    if (unlockButton) {
      unlockButton.addEventListener('click', () => {
        this.unlockVideo(this.currentVideo)
      })
    }
  }
}
